import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { currencyFormatterFactory } from "../utils";

export const PremiumSimulatorSummary = (
  { employeePart, employerPart, subtotal, taxes, total, titleKey },
  { intl }
) => {
  const formatCurrency = currencyFormatterFactory(intl);
  return (
    <div className="summary">
      <h4>
        <FormattedMessage id={titleKey} />
      </h4>
      <div>
        <dl>
          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.summary.employeePart" />
            </dt>
            <dd>{formatCurrency(employeePart)}</dd>
          </div>

          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.summary.employerPart" />
            </dt>
            <dd>{formatCurrency(employerPart)}</dd>
          </div>

          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.summary.subtotal" />
            </dt>
            <dd>{formatCurrency(subtotal)}</dd>
          </div>

          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.summary.taxes" />
            </dt>
            <dd>{formatCurrency(taxes)}</dd>
          </div>

          <div className="horizontalSummaryItem">
            <dt>
              <FormattedMessage id="clients.client.premiumSimulator.results.summary.total" />
            </dt>
            <dd>{formatCurrency(total)}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

PremiumSimulatorSummary.propTypes = {
  employeePart: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  employerPart: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  subtotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  taxes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  titleKey: PropTypes.string,
};

PremiumSimulatorSummary.contextTypes = { intl: intlShape };



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/Summary.js